export default __webpack_public_path__ + "images/SpeakersPhotos/Sergio_Gordillo_Improven.jpg?57556dba";